import React from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Copyright from '../../../components/Copyright';
import AppointmentScheduling from './AppointmentScheduling';

export default function Blog() {
  return (
    <>
        <Navbar />
        <AppointmentScheduling />
        <Footer />
        <Copyright />
    </>
  )
}